export default {
    dayNav: {
        prevDay: 'Prejšnji dan (Alt+←)',
        nextDay: 'Naslednji dan (Alt+→)',
    },
}
